import { h, Fragment } from "preact";
import unifyComponents from "../../helpers/components/unifyComponents";

export default function ProductOptionProperties({ variant }) {
  if (!variant) return null;

  const unifiedComponents = unifyComponents({
    variant,
    components: variant.components,
    multiComponents: variant.multiComponents,
  });

  const componentSkus = unifiedComponents
    .filter(({ variant }) => variant.sku)
    .map(
      ({ quantityEach, variant }) =>
        `${quantityEach}x ${variant.product.title} ${variant.sku}`,
    )
    .join(", ");

  return (
    <>
      {componentSkus.length > 0 && (
        <input
          type="hidden"
          name="properties[_components]"
          value={componentSkus}
        />
      )}
    </>
  );
}
